<template>
  <div>
    <form @keyup.enter="filter()" @submit.prevent>
      <div class="row pt-3 pb-3">
        <div v-if="buttonPrint != true" class="col-4">
          <text-input formGroupClass="flex-grow-1" v-model="form.searchText"
            placeholder="Pesquisar por cliente ou número da venda..." v-debounce:100ms="filter" />
        </div>
        <div class="col-6">
          <button type="button" class="btn btn-sm btn-primary mr-3" @click="showFilters = !showFilters">
            <i class="fas fa-filter mr-1" /> Mais Filtros
          </button>
          <button type="button" class="btn btn-sm btn-primary" @click="filter()">
            <i class="fas fa-search mr-1" /> Pesquisar
          </button>
        </div>

        <div v-if="buttonPrint == true" class="col text-right mr-4">
          <button type="button" class="btn btn-sm btn-primary" @click="print()">
            <i class="fas fa-print mr-1" /> Imprimir
          </button>
        </div>
      </div>
      <b-collapse v-model="showFilters">
        <b-row>
          <b-col cols="12" md="4">
            <salesman-search v-model="form.salesman_id" :name="salesman_name.value" />
          </b-col>

          <b-col cols="12" md="4">
            <client-search v-model="form.client_id" :name="client_name.value" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="2">
            <date-input v-model="form.saved_at_start" alias="Data Inicial" />
          </b-col>
          <b-col cols="12" md="2">
            <date-input v-model="form.saved_at_end" alias="Data Final" />
          </b-col>
          <b-col cols="12" md="2">
            <number-input v-model="form.max_value" alias="Valor Maior que" />
          </b-col>
          <b-col cols="12" md="2">
            <number-input v-model="form.min_value" alias="Valor Menor que" />
          </b-col>
        </b-row>

        <b-row align-v="center">
          <b-col align-h="between" class="pt-2">
            <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'o'"
              :unchecked-value="''" v-model="form.status">
              <small>Vendas</small>
            </b-form-checkbox>
            <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'p'"
              :unchecked-value="''" v-model="form.status">
              <small>Orçamentos</small>
            </b-form-checkbox>
            <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'d'"
              :unchecked-value="''" v-model="form.status">
              <small>Rascunho</small>
            </b-form-checkbox>
            <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'c'"
              :unchecked-value="''" v-model="form.status">
              <small>Canceladas</small>
            </b-form-checkbox>

            <div v-if="buttonPrint == true">
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'1'"
                :unchecked-value="''" v-model="form.payment_method">
                <small>Dinheiro</small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'2'"
                :unchecked-value="''" v-model="form.payment_method">
                <small>Cheque</small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'3'"
                :unchecked-value="''" v-model="form.payment_method">
                <small>Cartão Crédito</small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'4'"
                :unchecked-value="''" v-model="form.payment_method">
                <small>Cartão Débito</small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'5'"
                :unchecked-value="''" v-model="form.payment_method">
                <small>Crediário</small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'15'"
                :unchecked-value="''" v-model="form.payment_method">
                <small>Boleto Bancário </small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'16'"
                :unchecked-value="''" v-model="form.payment_method">
                <small>Depósito Bancário </small>
              </b-form-checkbox>


              <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'17'"
                :unchecked-value="''" v-model="form.payment_method">
                <small>PIX</small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'18'"
                :unchecked-value="''" v-model="form.payment_method">
                <small>Carteira Digital</small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="filter($event)" :value="'99'"
                :unchecked-value="''" v-model="form.payment_method">
                <small>Outros</small>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mt-2" md="2">
            <b-button @click="clear()" class="x-small" size="sm">
              <i class="fas fa-times" /> Limpar Filtro
            </b-button>
          </b-col>
        </b-row>
      </b-collapse>
    </form>
  </div>
</template>

<script>
import Form from "./../../mixins/Form.js";
import SalesmanSearch from "@/components/SalesmanSearch";
import ClientSearch from "@/components/ClientSearch";

import moment from "moment";

export default {
  components: {
    SalesmanSearch,
    ClientSearch,
  },
  props: {
    buttonPrint: {},
  },

  data: function () {
    return {
      showFilters: false,

      searchSalesmanResults: {},

      searchSalesmanLoading: false,

      salesman_name: {},
      client_name: {},
      payment_method: {
        1: {
          text: "Dinheiro",
          class: "badge-success",
        },

        2: {
          text: "Cheque",
          class: "badge-success",
        },

        3: {
          text: "Cartão de Credito",
          class: "badge-secondary",
        },
        4: {
          text: "Cartão de Débito",
          class: "badge-secondary",
        },
        5: {
          text: "Crediário",
          class: "badge-secondary",
        },
      },

      form: {
        text: null,
        max_value: null,
        min_value: null,
        saved_at_start: null,
        saved_at_end: null,
        status: ["d", "p", "o", ""],
        payment_method: ["1", "2", "3", "4", "5"],
        salesman_id: null,
      },
    };
  },

  watch: {
    form: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.$emit("input", this.form);
      },
    },
  },

  methods: {
    searchSalesman(search) {
      this.searchSalesmanLoading = true;

      axios
        .post("api/salesman/select?page=" + search.page, {
          name: search.text,
        })
        .then((response) => {
          this.searchSalesmanResults = response.data;

          this.searchSalesmanLoading = false;
        })
        .catch((error) => {
          this.error = error;
        });
    },

    setSalesman(salesman) {
      this.form.salesman_id.value = salesman.id;

      this.form.salesman.value = salesman.name;
    },

    clear() {
      this.salesman_name.value = null;
      this.form.text = null;
      this.form.max_value = 0;
      this.form.min_value = 0;
      this.form.saved_at_start = moment().subtract(30, "days").format("YYYY-MM-DD"),
        this.form.saved_at_end = moment().format("YYYY-MM-DD"),
        this.form.status = ["d", "p", "o",],
        this.form.payment_method = ["1", "2", "3", "4", "5"],
        this.form.salesman_id = null;

      this.$emit("filter");
    },

    filter() {
      this.$emit("filter");
    },

    print() {
      this.$emit("print");
    },
  },
};
</script>

<style></style>
